import React, { useState, useEffect } from 'react';
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  CircularProgress,
  Divider,
} from '@mui/material';
// import { Formik, Form } from 'formik';

import AddressForm from './Forms/AddressForm';
// import PersonalForm from './Forms/PersonalForm';
import PersonalForm from './Forms/PersonalForm_221116';
import PaymentForm from './Forms/PaymentForm';
import ReviewOrder from './ReviewOrder';
import CheckoutSuccess from './CheckoutSuccess';
import validationSchema from './FormModel/validationSchema';
import checkoutFormModel from './FormModel/checkoutFormModel';
import formInitialValues from './FormModel/formInitialValues';
import axios from 'axios';
import { useForm, useFieldArray, Controller, useWatch } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { setFileData } from 'actions/counter';

import useStyles from './styles';

const schema = yup.object().shape({
  // rankingPositions: yup
  //   .string()
  //   .required('rankingPositions is a required field'),
  // rankingPositions: yup.object().shape({
  //   code: yup.string().required('Informe o nome da filial!'),
  //   label: yup.string().required('Informe o cnpj!'),
  //   phone: yup.string().required('Informe o cnpj!'),
  // }),
  // rankingPositions: yup
  //   .object()
  //   .shape({
  //     id: yup.string().required('Informe o nome da filial!'),
  //     name: yup.string().required('Informe o nome da filial!'),
  //     rankingId: yup.string().required('Informe o cnpj!'),
  //     createdAt: yup.string().required('Informe o cnpj!'),
  //     updatedAt: yup.string().required('Informe o cnpj!'),
  //   })
  //   .nullable()
  //   .required('xxx'),
  // rankingPositions: yup.array().min(1, 'at least 1').required('required'),
  // file1Name: yup.mixed().required('File is required'),
  // .test('fileSize', 'too large', (value) => {
  //   console.log('---------yup---------');
  //   console.log(JSON.stringify(value));
  //   return value && value[0].size <= 100;
  // }),
  // registBirthPlace: yup
  //   .string()
  //   .required('registBirthPlace is a required field'),
  // addressPass15yr: yup.lazy(() =>
  //   yup.array().of(
  //     yup.object({
  //       yearFrom: yup.string().required('addressPass15yr is a required field'), // validate each object's entry
  //       // prop2: yup.number().required()  // independently
  //       // isPresentAddress: yup.array().min(1),
  //     })
  //   )
  // ),
  // engineerCertType: yup
  //   .string()
  //   .required('engineerCertType is a required field'),
  // isCollegeActivity: yup
  //   .string()
  //   .required('isCollegeActivity is a required field'),
  // // isCollegeActivity: yup.object().shape({
  // //   value: yup.string().required('isCollegeActivity is a required field'),
  // // }),
  // // gg: yup radio
  // // gg: yup validate object value
  // // gg: yup array of when
  // // gg: yup console.log
  // // gg: yup tutorial
  // // https://stackoverflow.com/questions/53727239/yup-js-check-array-when-condition
  // // collegeActivity: yup.lazy(() =>
  // //   yup.array().test({
  // //     message: 'test message',
  // //     test: (v) => {
  // //       console.log('in test', v);
  // //     },
  // //   })
  // // ),
  // // collegeActivity: yup.lazy(() =>
  // //   yup.array().when(['isCollegeActivity'], (val, schema) => {
  // //     console.log('when', val);
  // //   })
  // // ),
  // // collegeActivity: yup.lazy(() =>
  // //   yup.array().when(['isCollegeActivity'], (val, schema) => {
  // //     console.log('when', val);
  // //   })
  // // ),
  // collegeActivity: yup.array().when(['isCollegeActivity'], {
  //   is: 'Y',
  //   then: yup.array().of(
  //     yup.object().shape({
  //       dateFrom: yup.string().required('dateFrom is a required field'),
  //     })
  //   ),
  // }),
  // collegeActivity: yup.array().when(
  //   ['isCollegeActivity'],
  //   (val, schema) => {
  //     console.log('when', val);
  //   }
  //   // yup.array().of(
  //   // yup.object().shape({
  //   //   dateFrom: yup.string().when(['isCollegeActivity'], (val, schema) => {
  //   //     console.log('when', val);
  //   //   }),
  //   //   // dateFrom: yup.string().when('isCollegeActivity', {
  //   //   //   // is: (isCollegeActivity) => isCollegeActivity == null,
  //   //   //   // is: 'Y',
  //   //   //   is: (data) => data == 'Y',
  //   //   //   then: yup.string().required('yearFrom is a required field'), // validate each object's entry
  //   //   // }),
  //   // })
  // ),
  // collegeActivity: yup.lazy(() =>
  //   yup.array().of(
  //     yup.object({
  //       dateFrom: yup.string().when('isCollegeActivity', (val, schema) => {
  //         console.log('when', val);
  //       }),
  //       // dateFrom: yup.string().when('isCollegeActivity', {
  //       //   // is: (isCollegeActivity) => isCollegeActivity == null,
  //       //   // is: 'Y',
  //       //   is: (data) => data == 'Y',
  //       //   then: yup.string().required('yearFrom is a required field'), // validate each object's entry
  //       // }),
  //     })
  //   )
  // ),
  // collegeActivity: yup.lazy(() =>
  //   yup.array().of(
  //     yup.object({
  //       dateFrom: yup.string().required('yearFrom is a required field'), // validate each object's entry
  //     })
  //   )
  // ),
  firstName: yup
    .string()
    .matches(/^([^0-9]*)$/, 'First name should not contain numbers')
    .required('First name is a required field'),
  // lastName: yup
  //   .string()
  //   .matches(/^([^0-9]*)$/, 'Last name should not contain numbers')
  //   .required('Last name is a required field'),
  // positionType: yup
  //   .string()
  //   .required('positionType is a required field'),
  // title: yup.string().required('title is a required field'),
  // rankingPositions: yup
  //   .object()
  //   .nullable()
  //   .required('rankingPositions is required'),
  // file1Name: yup.mixed().required('File is required'),
  // isForeigner: yup.string().required('isForeigner is a required field'),
  // medicalProblem: yup.string().required('medicalProblem is a required field'),
  // addressPass15yr: yup.lazy(() =>
  //   yup.array().of(
  //     yup.object({
  //       yearFrom: yup.string().required('addressPass15yr is a required field'), // validate each object's entry
  //     })
  //   )
  // ),
  // presentAddressEmail: yup.string().email('Not a proper email'),
  // educations: yup.lazy(() =>
  //   yup.array().of(
  //     yup.object({
  //       eduClass: yup.string().required('eduClass is a required field'),
  //     })
  //   )
  // ),
  // eduOnApplicant: yup.string().required('eduOnApplicant is a required field'),
  // isCollegeActivity: yup
  //   .string()
  //   .required('isCollegeActivity is a required field'),
  // collegeActivity: yup.lazy(() =>
  //   yup.array().when(['isCollegeActivity'], {
  //     is: 'Y',
  //     then: yup.array().of(
  //       yup.object({
  //         dateFrom: yup
  //           .date()
  //           .required('dateFrom is a required field')
  //           .nullable(),
  //       })
  //     ),
  //   })
  // ),
  // othersLanguageSkill: yup.lazy(() =>
  //   yup.array().of(
  //     yup.object({
  //       speak: yup.string().required('speak is a required field'),
  //     })
  //   )
  // ),
  // computerSkills: yup.array().min(1, 'computerSkills at least 1').required(),
  // acceptAgreement: yup.array().min(1, 'acceptAgreement at least 1').required(),
});

const steps = [
  'Personal information',
  'Address information',
  'Education information',
  'Review information',
];

export default function EmploymentPage() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [errMsg, setErrMsg] = useState('');
  const currentValidationSchema = validationSchema[activeStep];
  const { user: currentUser } = useSelector((state) => state.auth);
  const [formValues, setFormValues] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const isLastStep = activeStep === steps.length - 1;
  const { formId, formField } = checkoutFormModel;
  const [isSubmittingFinal, setIsSubmittingFinal] = useState(false);
  const dispatch = useDispatch();

  const {
    control,
    handleSubmit,
    reset,
    getValues,
    setValue,
    formState: { isSubmitting, errors },
  } = useForm({
    defaultValues: {
      title: '---title---',
      positionType: '',
      firstName: '---firstName11---',
      lastName: '---lastName1---',
      // duputy: 'รวห.',
      // rankingPositions: [{ code: 'AF', label: 'Afghanistan', phone: '93' }],
      placeOfBirth: '---',
    },
    resolver: yupResolver(schema),
  });
  const rhf = {
    useForm,
    useWatch,
    useFieldArray,
    Controller,
    control,
    setValue,
    getValues,
    errors,
  };
  // const { useForm } = rhf;

  console.log('---isSubmitting----' + isSubmitting);

  async function _submitFormRhf(data) {
    await _sleep(200);
    alert(JSON.stringify(data, null, 2));
    // actions.setSubmitting(false);

    // insert TO DB
    const isSuccess = await addEmployee(data);
    if (!isSuccess) {
      alert(errMsg);
    } else {
      setActiveStep(activeStep + 1);
    }
  }

  const onSubmit = (data) => {
    if (isLastStep) {
      setIsSubmittingFinal(true);
      _submitFormRhf(data);
    } else {
      console.log('--------EmploymentPage---onSubmit-------');
      setActiveStep(activeStep + 1);
      // actions.setTouched({});
      // actions.setSubmitting(false);
    }
    console.log('data', data);
  };

  const updateForm = (data) => {
    // setFormValues(() => {
    //   return {
    //     ...formInitialValues,
    //     lastName: 'ทดสอบ',
    //   };
    // });
    // const [
    //   {
    //     firstName: vFirstName,
    //     lastName: vLastName,
    //     presentAddress,
    //     durationOfCourse: vDurationOfCourse,
    //   },
    // ] = data;

    //ค่าจาก database
    const {
      emp: {
        positionType: vPositionType,
        applicantNo: vApplicantNo,
        title: vTitle,
        idCard: vIdCard,
        firstName: vFirstName,
        lastName: vLastName,
        presentAddress,
        engName: vEngName,
        nickName: vNickName,
        weight: vEmpWeight,
        height: vEmpHeight,
        bloodGroupId: vBloodType,
        homeAddress: vHomeAddress,
        homeProvinceId,
        homeTambolId,
        homePostalCode: vHomePostalCode,
        presentAddress: vPresentAddressNo,
        // registProvinceId,
        homeProvinceCodeSAP,
        homeProvinceName,
        // registTambolId,
        homeTambolName,
        homeTambolDistrictId,
        homeTambolProvinceId,
        homeDistrictId,
        homeDistrictName,
        homeDistrictProvinceId,
        presentProvinceId,
        presentDistrictId,
        presentTambolId,
        presentProvinceCodeSAP,
        presentProvinceName,
        presentTambolName,
        presentDistrictName,
        presentPostalCode,
      },
      edu,
      // edu: [{ durationOfCourse }],
    } = data;
    // console.log(fname);

    const transformed = data.edu.map(({ durationOfCourse, startDate }) => ({
      eduPeriod: durationOfCourse,
      eduYearFrom: startDate,
    }));

    const vHomeAddressProvince = {
      id: homeProvinceId,
      codeSAP: homeProvinceCodeSAP,
      name: homeProvinceName,
    };

    const vHomeAddressTambol = {
      id: homeTambolId,
      name: homeTambolName,
      // districtId: registTambolDistrictId,
      // provinceId: registTambolProvinceId,
    };

    // const vRegistAddressTambol = {
    //   id: '2185',
    //   name: 'ตาจง',
    //   // districtId: registTambolDistrictId,
    //   // provinceId: registTambolProvinceId,
    // };

    // console.log(
    //   '-------000001-----vRegistAddressTambol---' +
    //     JSON.stringify(vRegistAddressTambol)
    // );

    const vHomeAddressDistrict = {
      id: homeDistrictId,
      name: homeDistrictName,
      // provinceId: registDistrictProvinceId,
    };

    // console.log(
    //   '-------000002-----vRegistAddressDistrict---' +
    //     JSON.stringify(vRegistAddressDistrict)
    // );

    const vPresentAddressProvince = {
      id: presentProvinceId,
      codeSAP: presentProvinceCodeSAP,
      name: presentProvinceName,
    };

    const vPresentAddressTambol = {
      id: presentTambolId,
      name: presentTambolName,
    };

    const vPresentAddressDistrict = {
      id: presentDistrictId,
      name: presentDistrictName,
    };

    //ไม่ได้ใช้
    const data2 = {
      ...formInitialValues,
      firstName: vFirstName,
      lastName: vLastName,
      educations: transformed,
      // educations: [
      //   {
      //     eduPeriod: durationOfCourse,
      //     eduYearFrom: '2',
      //     eduYearTo: '3',
      //   },
      // ],
    };
    // setFormValues(data2);

    //react-hook-from initial & transform data

    console.log('----homeDistrictId----' + homeDistrictId);

    const dataFromServer = {
      positionType: vPositionType,
      applicantNo: vApplicantNo,
      // salutations: '',
      title: vTitle,
      firstName: vFirstName,
      lastName: vLastName,
      nameEng: vEngName,
      idCard: vIdCard,
      nickName: vNickName,
      empWeight: vEmpWeight,
      empHeight: vEmpHeight,
      bloodType: vBloodType,
      isForeigner: 'N',
      addressPass15yr: [
        {
          // yearFrom: '2020',
          isPresentAddress: '',
          country: { id: 213, codeSAP: 'TH', name: 'ไทย' },
        },
        {
          // yearFrom: '2021',
          isPresentAddress: '',
          country: { id: 213, codeSAP: 'TH', name: 'ไทย' },
        },
      ],
      homeAddressNo: vHomeAddress,
      homeAddressProvince: vHomeAddressProvince,
      // homeAddressProvince: {
      //   id: 11,
      //   codeSAP: '09',
      //   name: 'ชลบุรี',
      // },
      homeAddressDistrict: vHomeAddressDistrict,
      // homeAddressDistrict: { id: 138, name: 'หนองใหญ่' },
      // homeAddressDistrict: {
      //   id: homeDistrictId,
      //   name: homeDistrictName,
      // },
      homeAddressTambol: vHomeAddressTambol,
      homeAddressPostal: vHomePostalCode,
      presentAddressNo: vPresentAddressNo,
      presentAddressProvince: vPresentAddressProvince,
      // presentAddressProvince: { id: 8, codeSAP: '64', name: 'สิงห์บุรี' },
      presentAddressDistrict: vPresentAddressDistrict,
      presentAddressTambol: vPresentAddressTambol,
      presentAddressPostal: presentPostalCode,
      medicalProblem: '',
      workOnRemoteSite: '',
      workOnRemoteSiteOccasion: '',
      educations: [{ eduClass: '' }],
      eduOnApplicant: '',
      engineerCert: '',
      isCollegeActivity: '',
      // collegeActivity: [
      //   {
      //     dateFrom: '',
      //   },
      // ],
      englishLanguageSkillSpeak: '',
      englishLanguageSkillRead: '',
      englishLanguageSkillWrite: '',
      englishLanguageCertificate: '',
      // othersLanguageSkill: [{ speak: '' }],
      othersLanguageSkill: [
        // {
        //   languageSkill: '',
        //   speak: '',
        //   read: '',
        //   write: '',
        //   certificate: '',
        // },
        // {
        //   languageSkill: '2',
        //   speak: '2',
        //   read: '2',
        //   write: '2',
        //   certificate: '2',
        // },
      ],
      isWorkExperience: '',
      trainingHistory: [{ companyName: '' }],
      computerSkills: ['2', '3'],
      militaryStatus: '',
      maritalStatus: '',
      acceptAgreement: [],
    };

    //react-hook-form ใช้ reset() ในการ set ค่าเริ่มต้น
    reset(dataFromServer);
  };

  // return { ...previousState, formField: { lastname: 'sss' } };

  const getDataFromAPI = () => {
    // Sample API to fetch Data
    console.log('API called!!');
    fetch('https://jsonplaceholder.typicode.com/users')
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        setTimeout(() => {
          // updateForm();
          setIsLoading(false);
          //delay 1200
        }, 400);
      });
  };

  const getEmployeeAndUpdate = async () => {
    console.log('getEmployeeAndUpdate', currentUser.username);
    // showLoader();
    try {
      // setErrorMessage('');
      const { data } = await axios.get('/api/cis/employee', {
        params: { employeeId: currentUser.username },
      });
      const {
        emp: { firstName: fname, lastName, presentAddress },
        edu: [{ durationOfCourse }],
      } = data;
      // const [
      //   {
      //     emp: { firstName: fname, lastName, presentAddress },
      //   },
      // ] = data;
      console.log('---EmploymentPage--getEmployeeAndUpdate 000 --> ', data);
      console.log('---EmploymentPage--getEmployeeAndUpdate 001 --> ', fname);
      console.log(
        '---EmploymentPage--getEmployeeAndUpdate 002 --> ',
        durationOfCourse
      );

      updateForm(data);
    } catch (error) {
      console.log(error.response);
    }
  };

  // setIsLoading(false);
  // const {
  //   values: { firstName: f1, file1Name },
  // } = formikProps;
  // console.log('formikProps', f1);
  // const { values, submitForm } = useFormikContext();
  // if (!f1) formikProps.setFieldValue('firstName', fname);
  // if (!f1) formikProps.setFieldValue('file1Name', file1Name);
  // setIsLoading(false);
  // setErrorMessage(
  //   error.response
  //     ? error.response.data.message || 'เกิดข้อผิดพลาดบางอย่าง'
  //     : 'เกิดข้อผิดพลาดบางอย่าง'
  // );

  function _renderStepContent(step) {
    switch (step) {
      case 0:
        // getDataFromAPI();

        // ยังมีปัญหาเรื่อง performance เพราะ render ตลอด
        console.log('_renderStepContent---case 0');

        //เคลียร์ค่าใน redux, แนบไฟล์
        // dispatch(
        //   setFileData({
        //     docType: 'file1Name',
        //     name: '',
        //     url: '',
        //   })
        // );

        // updateForm();
        return (
          <>
            {isLoading && (
              <div
                style={{
                  textAlign: 'center',
                }}
              >
                {/* https://www.geeksforgeeks.org/how-to-use-circularprogress-component-in-reactjs/ */}
                <CircularProgress color="primary" />
              </div>
            )}
            {!isLoading && (
              <PersonalForm
                formField={formField}
                rhf={rhf}
                // errors={errors}
                control={control}
              />
            )}
          </>
          // <PersonalForm formField={formField} />
        );
      case 1:
        console.log('_renderStepContent---case 1');
        return <AddressForm formField={formField} rhf={rhf} />;
      case 2:
        return <PaymentForm formField={formField} />;
      case 3:
        return <ReviewOrder rhf={rhf} />;
      default:
        return <div>Not Found</div>;
    }
  }

  function _sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // async function _submitForm(values, actions) {
  //   await _sleep(1000);
  //   alert(JSON.stringify(values, null, 2));
  //   actions.setSubmitting(false);

  //   //inset TO DB
  //   const isSuccess = await addEmployee(values);
  //   if (!isSuccess) {
  //     alert(errMsg);
  //   } else {
  //     setActiveStep(activeStep + 1);
  //   }
  // }

  // function _handleSubmit(values, actions) {
  //   if (isLastStep) {
  //     _submitForm(values, actions);
  //   } else {
  //     setActiveStep(activeStep + 1);
  //     actions.setTouched({});
  //     actions.setSubmitting(false);
  //   }
  // }

  function _handleBack() {
    setActiveStep(activeStep - 1);
  }

  //to backend: hr.cis.routes2.js --> CIS.js -- > insertOrUpdateEmployee
  const addEmployee = async (values) => {
    // console.log('saveNickname', nickname, userId)
    try {
      // setErrorMessage('')
      // setIsLoading(true)
      const {
        positionType,
        applicantNo,
        title,
        // idCard,
        firstName,
        lastName,
        address1,
        nameEng,
        nickName,
        empWeight,
        empHeight,
        bloodType,
        homeAddressNo,
        homeAddressProvince,
        homeAddressTambol,
        homeAddressDistrict,
        homeAddressPostal,
        presentAddressNo,
        presentAddressProvince,
        presentAddressDistrict,
        presentAddressTambol,
        presentPostalCode,
      } = values;
      const data = await axios.post('/api/cis/add-employee', {
        params: {
          positionType,
          applicantNo,
          title,
          idCard: currentUser.username,
          firstName,
          lastName,
          presentAddress: address1,
          nameEng,
          nickName,
          empWeight,
          empHeight,
          bloodType,
          homeAddressNo, //ที่อยู่ตามทะเบียนบ้าน
          homeAddressProvince,
          homeAddressTambol,
          homeAddressDistrict,
          homeAddressPostal,
          presentAddressNo, //ที่อยู่ปัจจุบันที่สามารถติดต่อได้
          presentAddressProvince,
          presentAddressDistrict,
          presentAddressTambol,
          presentPostalCode,
        },
      });
      console.log('addEmployee data', data);

      return true;
    } catch (error) {
      console.log('error-->frontend-->addEmployee', error);
      setErrMsg(JSON.stringify(error));

      return false;
    }
  };

  // setErrorMessage('');
  // setIsLoading(false);
  // setNickname(nickname);
  // setNicknameInfo('กรุณาเข้าระบบใหม่อีกครั้ง');
  // setOpenNicknameDialog(false);
  // setIsLoading(false);
  // setErrorMessage(
  //   error.response
  //     ? error.response.data.message ||
  //         'เกิดข้อผิดพลาดบางอย่าง โปรดลองอีกครั้ง'
  //     : 'เกิดข้อผิดพลาดบางอย่าง โปรดลองอีกครั้ง'
  // );
  // console.log(error.response)

  useEffect(() => {
    getDataFromAPI(); //test delay
    getEmployeeAndUpdate();
  }, []);

  return (
    <React.Fragment>
      <Typography
        component="h1"
        variant="h6"
        align="left"
        sx={{ color: 'primary.main' }}
      >
        บันทึกข้อมูลประกอบการจ้าง
        {/* {JSON.stringify(isSubmittingFinal)} */}
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <Stepper activeStep={activeStep} className={classes.stepper}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <React.Fragment>
        {activeStep === steps.length ? (
          <CheckoutSuccess />
        ) : (
          // <Formik
          //   initialValues={formValues || formInitialValues}
          //   validationSchema={currentValidationSchema}
          //   enableReinitialize
          //   onSubmit={_handleSubmit}
          // >
          //   {({ isSubmitting }) => (

          <form onSubmit={handleSubmit(onSubmit)}>
            {_renderStepContent(activeStep)}

            <div className={classes.buttons}>
              {activeStep !== 0 && (
                <Button onClick={_handleBack} className={classes.button}>
                  Back
                </Button>
              )}
              <div className={classes.wrapper}>
                <Button
                  disabled={isSubmittingFinal}
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.button}
                >
                  {isLastStep ? 'ส่งข้อมูลให้ HR' : 'Next'}
                </Button>
                {isSubmittingFinal && (
                  <CircularProgress
                    size={24}
                    className={classes.buttonProgress}
                  />
                )}
              </div>
            </div>
          </form>

          //   )}
          // </Formik>
        )}
      </React.Fragment>
    </React.Fragment>
  );
}
